module.exports = __webpack_public_path__ + "img/kids.cf83b51d.png";